export const GARAGE_PANEL_LOCATION = 'garage';
export const BASEMENT_PANEL_LOCATION = 'basement';
